import { border } from '@arcade/web'

export type ThemeBorder = typeof border

export default border
